import type { LifecycleVariant } from '@/stores/market-lifecycle-modal';

/**
 * Glow utility class for a variant. Applied to the SilkSheet's OUTER box (via
 * `sheetClassName`) — not the inner content div — so the two corner gradients
 * anchor to the modal's true top-left / top-right corners (FR-019), the same
 * way `prize-pool-card` hugs its card corners.
 */
export function lifecycleGlowClass(variant: LifecycleVariant): string {
  switch (variant) {
    case 'resolution-won-nonbacker':
    case 'resolution-won-backer':
      return 'lifecycle-glow-positive';
    case 'resolution-lost-nonbacker':
    case 'resolution-lost-backer':
      return 'lifecycle-glow-negative';
    default:
      return 'lifecycle-glow-brand';
  }
}
